import { FC } from "react";

import { displayOutcomeName } from "./helpers";

import { serverGetIndividualOutcomeScore } from "api/api-server-assessment";
import { SectionOutcomeType } from "components/server-types";
import { OutcomeChip } from "mds/components/OutcomeChip";
import { useCanAccessStudentSectionScores } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { outcomeSelectors, selectCurrentSectionId } from "store/selectors";
import { usePromiseEffect } from "store/store-hooks";

export const SectionOutcomeAverageScore: FC<{
  sectionOutcome: SectionOutcomeType;
  role?: "heading" | "listitem";
}> = ({ sectionOutcome, role }) => {
  const sectionId = useAppSelector(selectCurrentSectionId);
  const canAccessStudentSectionScores = useCanAccessStudentSectionScores();
  const outcome = useAppSelector((s) => outcomeSelectors.selectById(s, sectionOutcome.outcome_id));

  const { data: averageScore } = usePromiseEffect(async () => {
    if (!sectionId || !canAccessStudentSectionScores) {
      return null;
    }
    return serverGetIndividualOutcomeScore(sectionId, sectionOutcome.id);
  }, [sectionId, sectionOutcome.id, canAccessStudentSectionScores]);

  return <OutcomeChip role={role} score={averageScore} title={displayOutcomeName(outcome)} />;
};
